import * as Yup from "yup";

export const dataModel = {
  point01: "",
  point02: "",
  point03: "",
  point04: "",
  point05: "",
};

export const validationDataModel = () => {
  return Yup.object().shape({
    point01: Yup.number().required("forms.validations.required"),
    point02: Yup.number().required("forms.validations.required"),
    point03: Yup.number().required("forms.validations.required"),
    point04: Yup.number().required("forms.validations.required"),
    point05: Yup.number().required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
